import { UsuarioAuth, UsuarioAuthForm } from '@models/.';
import { transformUserRoleForm } from '..';

export function transformToData(user: UsuarioAuth | null): UsuarioAuth | null {
  if (!user) return null;
  
  return {
    ...user,
  };
}

export function transformToForm(user: UsuarioAuth): UsuarioAuthForm {
  const {
    id: id,
    nombre: firstName,
    apellido: lastName,
    dni: dni,
    direccion: address,
    ciudad: city,
    estado: state,
    pais: country,
    codigoPostal: postalCode,
    telefono: phone,
    correo: email,
    tienda_id: storeId,
    cuenta_id: accountId,
    estado_id: statusId,
    fechaCreacion: creationDate,
    fechaActualizacion: updateDate,
    nombreCompleto: fullName,
    rol: role
  } = user;

  return {
    id,
    firstName,
    lastName,
    dni,
    address,
    city,
    state,
    country,
    postalCode,
    phone,
    email,
    storeId,
    accountId,
    statusId,
    creationDate,
    updateDate,
    fullName,
    role: transformUserRoleForm(role),
  };
}